export default __webpack_public_path__ + "static/media/e-school.7b8bc0d2.png";